/**
 * Price bounds. These MUST match server/payments/money.go — the backend rejects
 * anything outside them with a 400, so a client that allows more just produces a
 * failed publish.
 */
export const MIN_PAID_PRICE_CENTS = 299;
export const MAX_PRICE_CENTS = 99_999;

/**
 * formatMoney renders integer minor units. Replaces the hardcoded
 * `$${price.toFixed(2)}` sites. Zero dependencies.
 *
 * ponytail: locale pinned to en-US and minor units assumed to be hundredths —
 * the whole UI is English and Phase 5b is USD-only. Upgrade path: take the
 * locale from an i18n layer, and read maximumFractionDigits from
 * Intl.NumberFormat().resolvedOptions() once a zero-decimal currency (JPY) ships.
 */
export function formatMoney(cents: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(cents / 100);
}
